export enum TaskComposerDataEventObjectsEnum {
  CREATE = 'create',
  CANCEL = 'cancel',
  VIEW = 'view',
}
